import type { Client, RequestContext } from "../client";
import type { NewSubscriptionResource, SubscriptionResource } from "../resources";
import { BasicRepository } from "./basicRepository";
export class SubscriptionRepository extends BasicRepository<SubscriptionResource, NewSubscriptionResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Subscriptions", client, requestContext);
    }
}
